import React from 'react';
import { ListParams } from '../types';
import { css, StyleSheet } from '../styling';
import { paginationDefaults } from '../commonSchema';
import { Clear as ClearIcon } from '@mui/icons-material';
import { FormControlLabel, Switch } from '@mui/material';

const styles = StyleSheet.create({
  deleteIcon: {
    position: 'relative',
    bottom: '2px',
    paddingRight: '10px',
    verticalAlign: 'middle',
    color: '#d0021b',
  },
});

type Props = {
  fieldName: string;
  label: string;
  listParams: ListParams;
  setGetListParams: (p: ListParams) => void;
  setSelectedRowItems: (p: []) => void;
  setQuickActionItem: (p: []) => void;
  setPagination?: (p: { page: number; page_size: number }) => void;
  paginationDefaults?: { page: number; page_size: number };
};

const DeletedFilterSwitch: React.FC<Props> = (props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <p>
        <ClearIcon className={css(styles.deleteIcon)} />
        {props.label}
      </p>
      <FormControlLabel
        control={
          <Switch
            checked={!props.listParams[props.fieldName as keyof ListParams]}
            onChange={(e) => {
              if (props.setPagination) {
                props.setPagination({
                  page: 1,
                  page_size: props.paginationDefaults
                    ? props.paginationDefaults.page_size
                    : paginationDefaults.page_size,
                });
              }
              props.setGetListParams({ ...props.listParams, [props.fieldName]: !e.target.checked });
              props.setSelectedRowItems([]);
              props.setQuickActionItem([]);
            }}
          />
        }
        label=""
        labelPlacement="start"
      />
    </div>
  );
};

export default DeletedFilterSwitch;
